module.exports = __webpack_public_path__ + "img/pix-icon.374e1825.svg";